import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { HostsSearch } from '../inputs/hosts_search'

export const TeamsScope = ({ selectedHostIds, setSelectedHostIds }) => (
  <>
    <BodyText>
      {I18n.t('publisher.event_types.filters.description.personal')}
    </BodyText>

    <HostsSearch
      selectedIds={selectedHostIds}
      setSelectedIds={setSelectedHostIds}
    />
  </>
)
